import React, { useContext } from "react";
import { Button, MenuItem } from "@chakra-ui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClipboardQuestion } from "@fortawesome/free-solid-svg-icons";
import ContentContext from "../../../common/context/ContentContext";
import ContentActionsContext from "../../../common/context/ContentActionsContext";
import { SizeAwareComponent } from "../../../store/types";


const KnowledgeCardButton = ({isMinimumSize}:SizeAwareComponent) => {
    const content = useContext(ContentContext);
    const contentActions = useContext(ContentActionsContext);

    return (
        <>
            {content && contentActions?.onViewKnowledge && (
                <>
                    <Button
                        colorScheme="telegram"
                        variant="outline"
                        leftIcon={<FontAwesomeIcon icon={faClipboardQuestion} />}
                        onClick={contentActions.onViewKnowledge}
                        title="Tarjetas de Estudio"
                        iconSpacing={isMinimumSize ? 1 : 0}
                    >
                        {isMinimumSize ? "Tarjetas de Estudio" : ""}
                    </Button>
                </>
            )}
        </>
    );
};

export const KnowledgeMenuItem = () => {
    const content = useContext(ContentContext);
    const contentActions = useContext(ContentActionsContext);

    return (
        <>
            {content && contentActions?.onViewKnowledge && (
                <>
                    <MenuItem
                        onClick={contentActions.onViewKnowledge}
                        icon={<FontAwesomeIcon icon={faClipboardQuestion} />}
                    >
                        Tarjetas de Estudio
                    </MenuItem>
                </>
            )}
        </>
    );
}

export default KnowledgeCardButton;
